import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

export const TabWithListStyles = styled(Container)`
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  width: 100%;
  max-width: 50rem;
  margin-left: auto;
  margin-right: auto;

  .tab-with-list__cta {
    max-width: 18.75rem;
    margin: 0 auto;
  }
`

export const TabContainerStyles = styled.div`
  .tabs {
    justify-content: center;
    width: 100%;
    overflow: auto;
    white-space: nowrap;
  }

  .tab__button {
    display: inline-block;
    margin-right: -10%;
    max-width: 11rem;
    width: 100%;
    background-color: rgba(var(--theme-palegray));
    color: rgba(var(--colors-text-dark-high));
    font-size: 0.75rem;
    transition: ease all 0.3s;

    &:hover:not(.tab__button--current) {
      z-index: 1;
    }
  }

  .tab__button:last-child {
    margin-right: 0;
  }

  .tab__button--current {
    z-index: 2;
    background-color: rgba(var(--colors-primary));
    color: #fff;
  }
  ${CONFIG.media.md} {
    .tab__button {
      max-width: 19rem;
      font-size: 1rem;
    }
  }
`

export const TabsWrapper = styled.div`
  padding: 0.5rem 0;
`

export const TabPanelStyles = styled.ul`
  display: grid;
  max-width: 40rem;
  width: 100%;
  margin: 0 auto;
  gap: 1.75rem;
  justify-content: center;
  ${CONFIG.media.md} {
    grid-template-columns: repeat(2, 1fr);
    padding-left: 2rem;
  }
  ${CONFIG.media.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const TabItemStyles = styled.li`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  width: 13.75rem;
  margin: 0 auto;

  .tab-item__icon {
    min-width: 4.05rem;
    height: 4.05rem;
    background-color: rgba(var(--theme-palegray));
    border-radius: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      object-fit: contain;
    }
  }

  .tab-item__label {
    overflow-wrap: break-word;
    word-wrap: break-all;
    hyphens: auto;
    text-align: start;
  }
`
